import React from "react";
import { CreateButton, ExportButton, FilterButton, SelectColumnsButton, TopToolbar, useListContext } from "react-admin";
import { CSV_ROWS } from "../config/constConfig";
import { SavedFilterScope } from "../api/saved_filters";
import { SavedFiltersMenu } from "./SavedFiltersMenu";

type Props = {
  filters?: React.ReactElement[];
  hasCreate?: boolean;
  preferenceKey?: string;
  savedFilterScope?: SavedFilterScope;
};

export const ListActions = ({ filters, preferenceKey, hasCreate, savedFilterScope }: Props) => {
  const { resource, exporter } = useListContext();

  return (
    <TopToolbar>
      {filters && <FilterButton filters={filters} disableSaveQuery />}
      {filters && savedFilterScope && <SavedFiltersMenu filters={filters} scope={savedFilterScope} />}
      {hasCreate && <CreateButton resource={resource} />}
      {exporter !== false && <ExportButton maxResults={CSV_ROWS} />}
      {preferenceKey && <SelectColumnsButton preferenceKey={preferenceKey} />}
    </TopToolbar>
  );
};
